import React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import '../../../styles/components/why-think-plus.scss'

const WhyThinkPlus = () => {
  let images = useStaticQuery(graphql`{
  EvolutionGold19: file(relativePath: {eq: "awards/EvolutionGold19.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  EvolutionSilver19: file(relativePath: {eq: "awards/EvolutionSilver19.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  EvolutionBronze19: file(relativePath: {eq: "awards/EvolutionBronze19.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  FranchiseAwards18: file(relativePath: {eq: "awards/FranchiseAwards18.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  MobileAwards18: file(relativePath: {eq: "awards/MobileAwards18.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  SWA_2016_Gold: file(relativePath: {eq: "awards/SWA_2016_Gold.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  SWA_2016_Silver: file(relativePath: {eq: "awards/SWA_2016_Silver.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  SWA_2015_Gold: file(relativePath: {eq: "awards/SWA_2015_Gold.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  SPI_GroupAward: file(relativePath: {eq: "awards/SPI_GroupAward.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  SWA_2013_Bronze: file(relativePath: {eq: "awards/SWA_2013_Bronze.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
  Efarmogiada_Award: file(relativePath: {eq: "awards/Efarmogiada_Award.png"}) {
    childImageSharp {
      gatsbyImageData(width: 150, layout: CONSTRAINED)
    }
  }
}
`)
  return (
    <section className="why-think-plus text-align-center">
      <div className="container medium">
        <h2 className="dec-header--underline">Why choose Think Plus?</h2>
        <p className="h5 why-think-plus__text">Because we are one of the first digital agencies in Greece.</p>
        <p>Because we have national and international awards. Because we grew up in a digital environment. Because we are the best value for money proposal in the market. <br />Because we have a lot of experience, credentials and clients. And most of all, because we results driven!</p>
        <div className="why-think-plus__awards">
          <div>
            <GatsbyImage
              image={images.EvolutionGold19.childImageSharp.gatsbyImageData}
              alt="E-volution Gold Award" />
            <strong>Gold Award</strong>
            <p>at the E-volution Awards for e-socks.gr ("Customer-oriented &amp; Procedures" - "Personalized Services")</p>
          </div>
          <div>
            <GatsbyImage
              image={images.EvolutionSilver19.childImageSharp.gatsbyImageData}
              alt="E-volution Silver Award" />
            <strong>Silver Award</strong>
            <p>at the E-volution Awards for Skroutz Application ("Electronic Business Services &amp; Infrastructure" - "Infrastructure Services")</p>
          </div>
          <div>
            <GatsbyImage
              image={images.EvolutionBronze19.childImageSharp.gatsbyImageData}
              alt="E-volution Bronze Award" />
            <strong>Bronze Award</strong>
            <p>at the E-Volution Awards for MEL ("Digital Cross &amp; Marketing" - "Best Cross Border Marketing")</p>
          </div>
          <div>
            <GatsbyImage
              image={images.FranchiseAwards18.childImageSharp.gatsbyImageData}
              alt="Franchise Gold Award" />
            <strong>Gold Award</strong>
            <p>at the Franchise Awards 2018 (Best use of Technology - "Smileworks")</p>
          </div>
          <div>
            <GatsbyImage
              image={images.FranchiseAwards18.childImageSharp.gatsbyImageData}
              alt="Franchise Gold Award" />
            <strong>Gold Award</strong>
            <p>at the Franchise Awards 2018 (Most Innovative Concept - "Smileworks")</p>
          </div>
          <div>
            <GatsbyImage
              image={images.MobileAwards18.childImageSharp.gatsbyImageData}
              alt="E-volution Bronze Award" />
            <strong>Second Prize</strong>
            <p>at Mobile Excellence Awards 2018 in the best Mobile Apps - "Fitgate"</p>
          </div>
          <div>
            <GatsbyImage
              image={images.SWA_2016_Gold.childImageSharp.gatsbyImageData}
              alt="Gold Social Media Award" />
            <strong>Gold Award</strong>
            <p>at the Social Media Awards 2016 (Best use of social media in Real Life)</p>
          </div>
          <div>
            <GatsbyImage
              image={images.SWA_2016_Silver.childImageSharp.gatsbyImageData}
              alt="Silver Social Media Award" />
            <strong>Silver Award</strong>
            <p>at the Social Media Awards 2016 "Innovation in Social Media"</p>
          </div>
          <div>
            <GatsbyImage
              image={images.SWA_2015_Gold.childImageSharp.gatsbyImageData}
              alt="Gold Social Media Award" />
            <strong>Gold Award</strong>
            <p>at the Social Media Awards 2015 (Best use of social media in Real Life)</p>
          </div>
          <div>
            <GatsbyImage
              image={images.SPI_GroupAward.childImageSharp.gatsbyImageData}
              alt="1st SPI Group Award" />
            <strong>First International Award</strong>
            <p>for Best Facebook Activation for the years 2012, 2013 &amp; 2014 (SPI Group)</p>
          </div>
          <div>
            <GatsbyImage
              image={images.SWA_2013_Bronze.childImageSharp.gatsbyImageData}
              alt="Bronze Social Media Award" />
            <strong>Two Social Media Awards</strong>
            <p>2013 Awards (Jägermeister &amp; Stolichnaya)</p>
          </div>
          <div>
            <GatsbyImage
              image={images.Efarmogiada_Award.childImageSharp.gatsbyImageData}
              alt="1st SPI Group Award" />
            <strong>Second prize</strong>
            <p>in the Greek "Application marathon” for the mobile application "FaceMetrics" under the auspices of the National Bank.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyThinkPlus